<template>
  <div class="legal-page">
    <div class="legal-container">
      <!-- Hero Section -->
      <div class="legal-hero">
        <h1>Refund & Return Policy</h1>
        <p class="lead">Clear guidelines for returns, refunds, and exchanges</p>
      </div>

      <!-- Main Content -->
      <div class="legal-content">
        <!-- Overview -->
        <section class="legal-section">
          <h2>Policy Overview</h2>
          <p>At SMASHING SHAPE, we want you to be completely satisfied with your purchase. If you're not happy with your order for any reason, we're here to help. This policy outlines the terms and conditions for returns, refunds, and exchanges.</p>
          <p><strong>Last Updated:</strong> December 2025</p>
        </section>

        <!-- Return Eligibility -->
        <section class="legal-section">
          <h2>Return Eligibility</h2>
          <p>You may return items within <strong>14 days</strong> of delivery if they meet the following conditions:</p>
          <ul>
            <li>Item is unused and in the same condition you received it</li>
            <li>Item is in original packaging with all tags attached</li>
            <li>Item includes all accessories, manuals, and documentation</li>
            <li>Proof of purchase (order number or receipt) is provided</li>
          </ul>

          <div class="info-box">
            <h3>Non-Returnable Items</h3>
            <p>The following items cannot be returned for hygiene and safety reasons:</p>
            <ul>
              <li>Personal care products (cosmetics, skincare, hygiene items)</li>
              <li>Perishable goods (food, flowers)</li>
              <li>Intimate or sanitary products</li>
              <li>Gift cards or downloadable products</li>
              <li>Custom or personalized items</li>
            </ul>
          </div>
        </section>

        <!-- How to Return -->
        <section class="legal-section">
          <h2>How to Initiate a Return</h2>
          <div class="step-list">
            <div class="step-item">
              <div class="step-number">1</div>
              <div class="step-content">
                <h3>Contact Us</h3>
                <p>Email <a href="mailto:public@smashingshape.com">public@smashingshape.com</a> or call <a href="tel:+2347011110034">070 1111 0034</a> with your order number and reason for return</p>
              </div>
            </div>
            <div class="step-item">
              <div class="step-number">2</div>
              <div class="step-content">
                <h3>Get Authorization</h3>
                <p>Our team will review your request and provide a Return Authorization (RA) number within 24 hours</p>
              </div>
            </div>
            <div class="step-item">
              <div class="step-number">3</div>
              <div class="step-content">
                <h3>Package Item</h3>
                <p>Pack the item securely in its original packaging, include the RA number inside the package</p>
              </div>
            </div>
            <div class="step-item">
              <div class="step-number">4</div>
              <div class="step-content">
                <h3>Ship Back</h3>
                <p>Use a trackable shipping method and keep your receipt. We'll provide a prepaid shipping label for defective items</p>
              </div>
            </div>
          </div>
        </section>

        <!-- Refund Process -->
        <section class="legal-section">
          <h2>Refund Process</h2>
          <p>Once we receive and inspect your return:</p>
          <ul>
            <li><strong>Inspection:</strong> We'll inspect the item within 2-3 business days</li>
            <li><strong>Approval:</strong> You'll receive an email notification once your refund is approved</li>
            <li><strong>Processing:</strong> Refund will be processed to your original payment method</li>
            <li><strong>Timeline:</strong> Allow 5-10 business days for the refund to appear in your account</li>
          </ul>

          <div class="info-box">
            <h3>Refund Amount</h3>
            <p>Your refund will include the purchase price of the item. Original shipping costs are non-refundable unless the return is due to our error or a defective product.</p>
          </div>
        </section>

        <!-- Exchanges -->
        <section class="legal-section">
          <h2>Exchanges</h2>
          <p>We gladly accept exchanges for the same item in a different size or color, subject to availability. To exchange an item:</p>
          <ul>
            <li>Follow the return process above and indicate you want an exchange</li>
            <li>We'll send the replacement item once we receive your return</li>
            <li>No additional shipping charges apply for exchanges</li>
          </ul>
        </section>

        <!-- Damaged or Defective Items -->
        <section class="legal-section">
          <h2>Damaged or Defective Items</h2>
          <p>If you receive a damaged or defective item:</p>
          <ul>
            <li>Contact us immediately (within 48 hours of delivery)</li>
            <li>Provide photos of the damage or defect</li>
            <li>We'll arrange for a replacement or full refund at no cost to you</li>
            <li>Return shipping will be covered by us via prepaid label</li>
          </ul>
        </section>

        <!-- Wrong Item Shipped -->
        <section class="legal-section">
          <h2>Wrong Item Received</h2>
          <p>If you receive the wrong item:</p>
          <ul>
            <li>Contact us within 48 hours with your order details</li>
            <li>Keep the item in its original condition</li>
            <li>We'll arrange pickup and send the correct item immediately</li>
            <li>No charges apply for our shipping errors</li>
          </ul>
        </section>

        <!-- Partial Refunds -->
        <section class="legal-section">
          <h2>Partial Refunds</h2>
          <p>In some cases, only partial refunds may be granted:</p>
          <ul>
            <li>Item showing obvious signs of use</li>
            <li>Item not in original condition or damaged by customer</li>
            <li>Item missing parts not due to our error</li>
            <li>Item returned more than 14 days after delivery</li>
          </ul>
        </section>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Refund',
  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>
